import { render, staticRenderFns } from "./shipping-type.vue?vue&type=template&id=e015e276&scoped=true"
import script from "./shipping-type.vue?vue&type=script&lang=js"
export * from "./shipping-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e015e276",
  null
  
)

export default component.exports